//If gateway returns an error with any of these keys, we will map it to a generic message
//otherwise we will just display the error
export const GATEWAY_ERROR_MAP = {
    interval: 'Frequency',
    intervalAmount: 'Budget',
    transactionLimit: 'Transaction limit',
    startDate: 'Start date',
    endDate: 'End date',
    allowedCategories: 'Allowed Merchant Categories',
    allowedCategoryGroups: 'Allowed Merchant Category Groups',
    allowedVendor: 'Allowed Vendors',
    attn: 'Recipient Name in Shipping Address',
    address1: 'Street Address in Shipping Address',
    address2: 'Street Address in Shipping Address',
    city: 'City in Shipping Address',
    state: 'State in Shipping Address',
    country: 'Country in Shipping Address',
    zipCode: 'Postal Code in Shipping Address'
};
export const parseCardsGatewayError = (error) => {
    if (!error) {
        return [];
    }
    const errors = [];
    function getErrorMessage(key, obj) {
        if (key in GATEWAY_ERROR_MAP) {
            errors.push(`${GATEWAY_ERROR_MAP[key]} is invalid`);
            return;
        }
        if (typeof obj === 'string') {
            errors.push(obj);
            return;
        }
        Object.keys(obj).forEach((objKey) => {
            getErrorMessage(objKey, obj[objKey]);
        });
    }
    try {
        const errorObject = JSON.parse(error);
        getErrorMessage('', errorObject);
        return errors;
    }
    catch (e) {
        return [error];
    }
};
